import React from 'react';
import { Code2, Sparkles } from 'lucide-react';
import { mockProfile } from '../mock';
import './Hero.css';

import StarBorder from './utils/StarBorder'

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Sparkles size={16} />
            <span>Available for Projects</span>
          </div>
          <h1 className="hero-title">
            Hi, I'm <span className="hero-name">{mockProfile.name}</span>
          </h1>
          <p className="hero-subtitle">{mockProfile.title}</p>
          <p className="hero-description">{mockProfile.bio}</p>
          <div className="hero-actions">
            <StarBorder 
              as='button'
              className='btn-primary'
              color='white'
              speed='5s'
              thickness = {2}
            >
              Contact Me
            </StarBorder>
            <a 
              href="https://github.com/xerpxz" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              <Code2 size={18} />
              <span>View GitHub</span>
            </a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-glow"></div>
          <div className="hero-grid"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;